// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfl_a bhk_wh bhk_sq bhk_xj"};